export const AutoCheckFeedbackItemFragment = gql`
  fragment AutoCheckFeedbackItemFragment on AutoCheckFeedbackItem {
    id
    feedbackText
    severity
    sourceRuleType
    createdAt
    resolvedAt
    codeBookItem {
      ...CodeBookItemFragment
    }
  }
`

export const AutoCheckExecutionFragment = gql`
  fragment AutoCheckExecutionFragment on AutoCheckExecution {
    id
    executedAt
    autoCheckFeedbackItems {
      ...AutoCheckFeedbackItemFragment
    }
  }
`

export const AutoCheckFeedbackUpdateFragment = gql`
  fragment AutoCheckFeedbackUpdateFragment on AutoCheckFeedbackUpdate {
    executionId
    isDone
    feedback {
      ...AutoCheckFeedbackItemFragment
    }
  }
`
